<button class="text-gray-900 rounded-full" [ngClass]="styles">
    <mat-icon class="h-6 w-6"> {{ name }}</mat-icon>
</button>